import type { ReactNode } from "react";
import { lazy } from "react";
import { Route } from "react-router-dom";
import { AppRoutes, type PublicRoutePath } from "@/infra/router";

const RootPage = lazy(() => import("@/pages/RootPage"));
const HomePage = lazy(() => import("@/pages/HomePage"));
const BridgeToDesktopPage = lazy(() => import("@/components/onboarding/BridgeToDesktopPage"));
const ReactionFromEmailSuccessPage = lazy(() => import("@/pages/ReactionFromEmailSuccessPage"));
const PaymentSuccessPage = lazy(() => import("@/pages/PaymentSuccessPage"));
const TermsAndConditionsPage = lazy(() => import("@/pages/legal/TermsAndConditionsPage"));
const PrivacyPolicyAndDataTransparencyPage = lazy(() => import("@/pages/legal/PrivacyPolicyAndDataTransparencyPage"));
const IFUPage = lazy(() => import("@/pages/legal/IFUPage"));

const publicRouteMap = {
    [AppRoutes.Home]: <HomePage />,
    [AppRoutes.BridgeToDesktop]: <BridgeToDesktopPage />,
    [AppRoutes.ReactionsFromEmail]: <ReactionFromEmailSuccessPage />,
    [AppRoutes.TermsAndConditions]: <TermsAndConditionsPage />,
    [AppRoutes.PrivacyPolicyAndDataTransparency]: <PrivacyPolicyAndDataTransparencyPage />,
    [AppRoutes.IFU]: <IFUPage />,
    [AppRoutes.PaymentSuccess]: <PaymentSuccessPage />,
} satisfies Record<PublicRoutePath, ReactNode>;

export const PUBLIC_ROUTES = [
    <Route key="root" path="/" element={<RootPage />} />,
    ...Object.entries(publicRouteMap).map(([path, element]) => (
        <Route key={path} path={path} element={element} />
    )),
];
